'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from '@/context/LanguageContext';
import styles from './Footer.module.scss';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <h3 className={styles.logo}>{t.nav.logo}</h3>
          <p className={styles.address}>
            {t.footer.address.street}<br />
            {t.footer.address.zip}<br />
            {t.footer.address.country}
          </p>
          <p className={styles.contact}>
            <a href="mailto:info@klonkaffe.dk">info@klonkaffe.dk</a><br />
            <a href="tel:+4526136974">+45 2613 6974</a>
          </p>
          <p className={styles.cvr}>{t.footer.cvr}</p>
        </div>

        <div className={styles.links}>
          <h4>{t.footer.shopHeading}</h4>
          <Link href="/shop">{t.footer.allProducts}</Link>
          <Link href="/abonnement">{t.footer.coffeeSubscription}</Link>
          <Link href="/om">{t.footer.aboutUs}</Link>
          <Link href="/handelsbetingelser">{t.footer.terms}</Link>
        </div>

        <div className={styles.links}>
          <h4>{t.footer.followUs}</h4>
          <a
            href="https://www.instagram.com/klonkaffe"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
        </div>

        <div className={styles.smiley}>
          <h4>{t.footer.controlReport}</h4>
          <a
            href="https://www.findsmiley.dk/1486144"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src="/media/site/findsmiley-banner.gif"
              alt={t.footer.smileyAlt}
              width={200}
              height={65}
              unoptimized
            />
          </a>
        </div>
      </div>

      <div className={styles.bottom}>
        <p>&copy; {new Date().getFullYear()} KlonKaffe. {t.footer.copyright}</p>
      </div>
    </footer>
  );
}
